export interface IMenuItem {
    label: string;
    path?: string;
    disabled?: boolean;
  }
  
  export interface IManagementNavbarProps {
    label: string;
    menuItems: IMenuItem[];
    path: string;
  }
  
export const initialNavbarSections: IManagementNavbarProps[] = [
    {
        label: "Klienten-Verwaltung",
        menuItems: [
            {
                label: "Klientenübersicht",
                path: "/LeadOverview",
                disabled: false
            },
            {
                label: "Klient erstellen",
                path: "/import-lead/create",
                disabled: false
            }
        ],
        path: ""
    },
    {
        label: "Bewerber-Verwaltung",
        menuItems: [
            { label: "Bewerber", path: "/", disabled: true },
            { label: "Neuer Bewerber", path: "/", disabled: true }
        ],
        path: "/"
    },
    {
        label: "Buchungsverwaltung",
        menuItems: [
            {
                label: "Buchungen",
                path: "/:supperId/booking",
                disabled: false
            },
            { label: "Neue Buchung", path: "/new-client", disabled: true }
        ],
        path: ""
    }
];
